"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const Search = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.54 4a6.54 6.54 0 0 1 5.278 10.403l3.97 3.97a1 1 0 0 1-1.32 1.497l-.095-.083-3.97-3.97A6.54 6.54 0 1 1 10.54 4zm0 2a4.54 4.54 0 1 0 0 9.08 4.54 4.54 0 0 0 0-9.08z" }));
exports.default = Search;
//# sourceMappingURL=index.js.map